import * as React from "react";
import {translate} from "react-i18next";
import {ITranslatedComponent} from "../../../../redux/reducers/generalReducer";
import {ProMTGroupDto, UserDto} from "../../../../services/Client";
import {
    createAssignedProMTGroupUsers
} from "../../AdminUtils";
import UserSelection from "./UserSelection";

interface IAssignedGroupSelectionProps extends ITranslatedComponent {
    /** All available roles. */
    users: UserDto[];

    /** The parent DTO of the AssignedGroups. */
    parentDto: ProMTGroupDto;

    /** Initially selected assigned groups. */
    values?: UserDto[];

    /** Callback when the selected roles change. */
    onChange: (assignedUsers: UserDto[]) => any;
}

class AssignedUserSelection extends React.Component<IAssignedGroupSelectionProps> {
    render() {
        return (
            <>
                <UserSelection
                    placeholder={this.props.t("SELECT_USERS")}
                    users={this.props.users}
                    values={this.props.values || []}
                    onChange={(users: UserDto[]) => this.props.onChange(createAssignedProMTGroupUsers(users, this.props.parentDto))}
                />
            </>
        );
    }
}

export default translate("ADMIN_VIEW")(AssignedUserSelection);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/ProMTGroupsTab/AssignedUserSelection.tsx